import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_DIALOG_SCHEMA = Object.freeze({
  DIALOG_IDENTIFIER: '',
});
const RECORD = generateSchema(TRACKING_DIALOG_SCHEMA);
const KEYS: any = generateKeys(TRACKING_DIALOG_SCHEMA);

export class DialogTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.dialog;
  }

  get properties() {
    return this.toJS();
  }
}
